{
  "mandatoryFields": {
    "part1": "Los campos precedidos de un",
    "part2": "son obligatorios."
  },
  "confirm": {
    "leave": {
      "page": {
        "title": "¿Salir de la página?",
        "message": {
          "unsavedData": "Se han realizado cambios y no se guardarán. ¿Desea salir de la página?"
        }
      }
    },
    "okLabel": "Confirmar",
    "cancelLabel": "Cancelar",
    "cancel": {
      "title": "¿Anular los cambios?",
      "message": "Se han realizado cambios y no se guardarán. ¿Anular los cambios?"
    }
  },
  "noData": "Sin datos"
}
